import PropTypes from 'prop-types';
import React from 'react';
import {I18n} from 'react-redux-i18n';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import {validatePassword} from '../util';

class ResetPasswordInput extends React.Component {
  systemId = null;
  stateObj = {
    plainTextField: false,
    error: false
  }

  constructor() {
    super();
    this.systemId = localStorage.getItem('systemId');
    if (this.systemId && this.systemId === 'geotab') {
      this.stateObj.disabled = true;
      this.stateObj.isFocused = false;
    }

    this.state = this.stateObj;
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.bool,
    disabled: PropTypes.bool
  }

  static defaultProps = {
    value: '',
    label: '',
    error: false,
    disabled: false
  }

  

  toggleFieldType = () => {
    this.setState({plainTextField: !this.state.plainTextField});
  }

  onChange = ({target: {value}}) => {
    const valid = this.isPasswordValid(value);

    const event = {
      value,
      valid
    };

    this.props.onChange(event);

    this.setState({
      error: !valid
    })
  }

  onFocus = () => {
    if (this.systemId && this.systemId === 'geotab') {
      this.setState({
        isFocused: true
      });
    }
  }

  handleDisabled = e => {
    if (this.systemId && this.systemId === 'geotab') {
      const disabled = this.isEventBlurOrMouseLeave(e);
      this.setState({ 
        disabled
      });
    }
  }

  isEventBlurOrMouseLeave = (e) => {
    const isBlur = e.type === 'blur';
    if (isBlur) {
      this.setState({
        isFocused: false
      });
    }
    return (e.type === 'blur' || (e.type === 'mouseleave' && !this.state.isFocused));
  }

  isPasswordValid(password) {
    const validation = validatePassword(password);
    return !validation.error;
  }

  render() {
    return (
      <React.Fragment>
        <TextField
          label={I18n.t(this.props.label)}
          name="password"
          type={this.state.plainTextField ? 'text' : 'password'}
          value={this.props.value}
          onBlur={this.handleDisabled}
          onChange={this.onChange}
          onClickCapture={this.handleDisabled}
          onFocus={this.onFocus}
          onMouseOver={this.handleDisabled}
          onMouseLeave={this.handleDisabled}
          onPointerOver={this.handleDisabled}
          error={this.state.error || this.props.error}
          disabled={
            this.systemId && this.systemId === 'geotab' ? 
            this.state.disabled :
            this.props.disabled
          }
          className="settings__password-field"
        />
        <IconButton className="settings__password-icon" onClick={this.toggleFieldType}>
          <Icon>{this.state.plainTextField ? 'visibility_off': 'visibility'}</Icon>
        </IconButton>
      </React.Fragment>
    );
  }
}


export default ResetPasswordInput;
